import Squares from "./footerBackground/footerBackGround";

export default function Footer() {
    return (
        <div className="position-relative">
            <div className="position-absolute top-50 start-50 translate-middle text-center">
                © Copyright Arash All Rights Reserved
                <br />
                Designed by ARASH
            </div>
            <Squares
                speed={0.5}
                squareSize={50}
                direction='down' // up, down, left, right, diagonal
                borderColor='lighgray'
                hoverFillColor='#686868'
            />
        </div>
    );
}